import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import YouTubeCard from "./YouTubeCard";
import YouTubePlayer from "./YouTubePlayer";
import "./style.css";
import axios from "axios";

import EditPostPopup from "../../editPostPopup";

export default function YouTubeFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPost, setSelectedPost] = useState(null);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [editingPost, setEditingPost] = useState(null);

  // Edit/Delete handlers
  const handleEditPost = (post) => setEditingPost(post);
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
  };

  const categories = [
    { id: "all", name: "Todos" },
    { id: "music", name: "Música" },
    { id: "gaming", name: "Games" },
    { id: "education", name: "Educação" },
    { id: "entertainment", name: "Entretenimento" },
    { id: "sports", name: "Esportes" },
    { id: "news", name: "Notícias" },
    { id: "tech", name: "Tecnologia" },
  ];

  const fetchPosts = async (pageNum = 1, cat = category) => {
    try {
      const categoryParam = cat !== "all" ? `&category=${cat}` : "";
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/feed/youtube?page=${pageNum}&limit=12${categoryParam}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      if (pageNum === 1) {
        setPosts(data.posts || []);
      } else {
        setPosts((prev) => [...prev, ...(data.posts || [])]);
      }
      const pagination = data.pagination || {};
      setHasMore(pagination.page < pagination.pages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching YouTube feed:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchPosts();
  }, []);

  const handleCategoryChange = (newCategory) => {
    setCategory(newCategory);
    setPage(1);
    setLoading(true);
    fetchPosts(1, newCategory);
  };

  const loadMore = () => {
    if (hasMore && !loading) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchPosts(nextPage);
    }
  };

  if (loading && posts.length === 0) {
    return (
      <div className="youtube_feed_loading">
        <div className="youtube_loader"></div>
        <span>Carregando vídeos...</span>
      </div>
    );
  }

  return (
    <div className="youtube_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => handleCategoryChange(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Videos Grid */}
      {posts.length === 0 ? (
        <div className="youtube_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73z" />
          </svg>
          <h3>Nenhum vídeo encontrado</h3>
          <p>Seja o primeiro a publicar um vídeo!</p>
        </div>
      ) : (
        <>
          <div className="youtube_grid">
            {posts.map((post) => (
              <YouTubeCard
                key={post._id}
                post={post}
                user={user}
                onClick={setSelectedPost}
                onEdit={handleEditPost}
                onPostDeleted={handlePostDeleted}
              />
            ))}
          </div>

          {hasMore && (
            <div className="youtube_load_more">
              <button onClick={loadMore} disabled={loading}>
                {loading ? "Carregando..." : "Carregar mais"}
              </button>
            </div>
          )}
        </>
      )}

      {/* Video Player Modal */}
      {selectedPost && (
        <YouTubePlayer
          post={selectedPost}
          onClose={() => setSelectedPost(null)}
        />
      )}

      {/* Edit Post Modal */}
      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={() => setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
